// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TRY_FORUM_PANEL__BTN = "Zeptej se v diskuz\u00edch";
export const TRY_FORUM_PANEL__TEXT = "Nena\u0161la jsi odpov\u011b\u010f na svou ot\u00e1zku?";
